import styled from 'styled-components';
import {
  breakpointMediumStart,
  spacing2,
  spacing3,
  spacing4,
} from 'lib/mortar';
import {
  LocationWrapper,
  SearchInputWrapper,
  SecondLevelWrapper,
} from 'components/Search/styles';

export const AnchorForm = styled.form`
  display: flex;
  margin-right: -${spacing2};
  @media (min-width: ${breakpointMediumStart}) {
    margin-bottom: ${spacing2};
  }
`;

export const Content = styled.div<StyledDiv>`
  box-sizing: border-box;
  width: 100%;
  max-width: 660px;
  margin: 0 auto;
  padding: ${spacing3} ${spacing2} ${spacing2};
  position: relative;

  padding: ${spacing2} ${spacing4};
  display: flex;
  column-gap: ${spacing4};

  ${AnchorForm} {
    margin-right: 0;
    flex-grow: 1;
  }

  #search-form {
    margin: 0;
    padding: ${spacing2} 0;
    flex-direction: column;
    row-gap: ${spacing3};
    flex-grow: 1;

    ${SearchInputWrapper} {
      margin: 0;
    }

    ${SecondLevelWrapper} {
      flex-direction: row;
      row-gap: ${spacing3};

      ${LocationWrapper} {
        margin-right: 0;
      }
    }

    @media (min-width: ${breakpointMediumStart}) {
      padding: 0;
      flex-direction: row;
      column-gap: ${spacing2};

      ${SearchInputWrapper} {
        margin: 0;
      }

      ${SecondLevelWrapper} {
        flex-direction: row;
        column-gap: ${spacing2};
      }
    }
  }

  @media (min-width: ${breakpointMediumStart}) {
    ${AnchorForm} {
      margin-bottom: 0;
    }
  }
`;
